import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Client } from "@/api/clients";
import { UserPermissions, fetchUserInfo, UserIdentity } from "@/api/user";


export interface UserState {
    clientId: number | null;
    id: number | null;
    lvtc: string | null;
    lvtu: string | null;
    lvtr: string | null;
    username: string | null;
    name: string | null;
    permissions: UserPermissions | null;
    userClient: Client | null;
    token: string | null;
    timeZone: string | null;
    videoPreference: string | null;
    sessionStart: string | null;
}

const initialState: UserState = {
    clientId: null,
    id: null,
    lvtc: null,
    lvtu: null,
    lvtr: null,
    username: null,
    name: null,
    permissions: null,
    userClient: null,
    token: null,
    timeZone: null,
    videoPreference: null,
    sessionStart: null,
};

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUserIdentity: (state, action: PayloadAction<UserIdentity>) => {
            const { userId: id, userToken: token, clientId } = action.payload;

            state.id = id;
            state.token = token;
            state.clientId = clientId;
        },
        setUserClient(state, action: PayloadAction<Client | null>) {
            state.userClient = action.payload;
        },
        setUserSession(state) {
            const now = new Date();

            state.sessionStart = now.toISOString();
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchUserInfo.fulfilled, (state, action) => {
            const { id, lvtc, lvtu, lvtr, permissions, name, videoPreference, timeZone, username } = action.payload;

            state.id = id;
            state.lvtc = lvtc;
            state.lvtu = lvtu;
            state.lvtr = lvtr;
            state.name = name;
            state.permissions = permissions;
            state.videoPreference = videoPreference;
            state.timeZone = timeZone;
            state.username = username;
        });
    },
});

export const { setUserIdentity, setUserClient, setUserSession } = userSlice.actions;
export const userReducer = userSlice.reducer;
